import React from 'react';
import { connect } from 'react-redux';
import { toggleSingleView, deleteCameraInView } from '../../actions';
import '../../App.css';
import loading_icon from '../../loading_icon.jpeg';
import { isSafari } from 'react-device-detect';

class Stream extends React.Component {
  constructor(props) {
    super(props);

    // Reference to video (i.e. <video> element)
    this.videoElement = React.createRef();
    // Websocket instance
		this.oWS = null;
    // Media source instance
    this.oMS = null;
    // Source buffer instance
		this.oSourceBuffer = null;

    this.state = {
      connectionRetry: 0,
      connectionRetryLimit: 6,
      max_queue_len: 20,
      verbose: false,
      mimeType: "video/mp4",
      codecs: "avc1.4D401F", // https://wiki.whatwg.org/wiki/Video_type_parameters,
      codecPars: "video/mp4;codecs=avc1.4D401F", // If stream has audio, remember to include it in these definitions.. otherwise your mse goes sour
      sVideoElementID: null,
      queue: [], // Queue for incoming packets
      feed_direct: true,
      stopped: false,
      packets: 0,
      loading: false,
      ts: '',
      motion: false,
      connectionFail: false,
      metaloaded: false
    };
     // add window listeners for page blur/focus
    window.addEventListener('focus', this.focus );
    window.addEventListener('blur', this.blur );
	};

  componentDidMount = async () => {
    await this.jumpStart();
    // if the device is online attempt the initial loading connection of 10 seconds - othervise continue do 3 sec and move to retries in the background
    // this is basically just to show the user that we are trying to connect the first time and on subsequent window onFocus events
    let connectionWait = this.props.deviceOnline === 1 ? 10000 : 3000;

    setTimeout(() => {
      if(this.state.loading && !this.state.metaloaded){
        this.setState({ connectionFail: true, loading: false });
      };
    }, connectionWait);

    setTimeout(() => {
      if(this.state.connectionFail){
        this.retryConnection();
      };
    }, 20000)
  };

  componentWillUnmount = () => {
    window.removeEventListener('focus', this.focus );
    window.removeEventListener('blur', this.blur );
    if(this.videoElement && this.videoElement.current){
      this.videoElement.current.removeEventListener('loadeddata', this.loaded.bind(this) );
      this.videoElement.current.removeEventListener('loadedmetadata', this.metaloaded.bind(this) );
    };
  };

  retryConnection = async () => {
    console.log('attempting to recoonect to camera stream. ' + this.props.camera.sDeviceID + ' - ' + this.props.camera.bCamera)
    let retryCount = this.state.connectionRetry;
    // console.log(retryCount)
    if(retryCount >= 4 && retryCount <= 7){
      this.setState({
        connectionRetry: retryCount + 1,
      }, async () => {
          await this.videoElement.current.setAttribute('src', this.initMediaSource());
          setTimeout(() => {
            if(this.state.connectionFail){
              this.retryConnection();
            };
          }, 30000); // run it every30 seconds
      });

    } else if (retryCount > 7 && retryCount <= 10) {
        setTimeout(() => {
          if(this.retryCount >= 20){
            this.setState({ connectionFail: true, loading: false, connectionRetry: 0 });
          } else {
             this.setState({
                connectionRetry: retryCount + 1
              }, async () => {
                  await this.videoElement.current.setAttribute('src', this.initMediaSource());
                    if(this.state.connectionFail){
                      this.retryConnection();
                    };
              });
          };
        }, 45000 ); // every 45 seconds run it again

    } else {
        this.setState({
          connectionRetry: retryCount + 1
        }, async () => {
            await this.videoElement.current.setAttribute('src', this.initMediaSource());
            setTimeout(() => {
              if(this.state.connectionFail){
                this.retryConnection();
              };
            }, 10000); // run it again after 10 second
        });
    };
  };

  jumpStart = (retry) => {
    this.setState({
      max_queue_len: 20,
      verbose: false,
      mimeType: "video/mp4",
      codecs: "avc1.4D401F", // https://wiki.whatwg.org/wiki/Video_type_parameters,
      codecPars: "video/mp4;codecs=avc1.4D401F", // If stream has audio, remember to include it in these definitions.. otherwise our mse goes sour
      sVideoElementID: null,
      queue: [], // Queue for incoming packets
      feed_direct: true,
      packets: 0,
      loading: true,
      metaloaded: false,
      motion: this.state.motion
    }, async () => {
      // add listener for stalled event on videoElement
      this.videoElement.current.addEventListener('stalled', this.stalled.bind(this) );
      // may split the bottom 2 out into their own function calls
      this.videoElement.current.addEventListener('loadeddata', this.loaded.bind(this) );
      this.videoElement.current.addEventListener('loadedmetadata', this.metaloaded.bind(this) );
      await this.videoElement.current.setAttribute('src', this.initMediaSource());
    })
  }

  loaded = () => {
    this.setState({ loading: false, connectionRetry: 0, connectionFail: false })
  };

  metaloaded = () => {
    this.setState({ metaloaded: true, loading: true, connectionRetry: 0, connectionFail: false })
  };

	stalled = () => {
		console.log('Stream Stalled');
		this.jumpStart();
	};

	focus = () => {
		if( this.state.stopped ) {
			this.jumpStart();
		};
	};

	blur = () => {
    // see why the following doesn't work to stop the stream to save bandwidth usage
    // this function does not seem to actually change anything....
		// this.stop();
	};

  stop() {
    // console.log('stop called')
    // this.setState({ stopped: true }, () => {
    //   if(this.videoElement && this.videoElement.current){
    //     this.videoElement.current.removeEventListener('stalled', this.stalled.bind(this) );
    //     this.videoElement.current.removeEventListener('loadeddata', this.loaded.bind(this) );
    //     this.videoElement.current.setAttribute('src', null);
    //   };
    // });
	};

	visabilityChanged = () => {
		if(document.hidden) {
			console.log('Hidden');
			this.stop()
		} else {
			console.log('Visible');
			if( this.state.stopped )
				this.play();
		};
	};

  initMediaSource = () => {
		// create media source instance
		this.oMS = new MediaSource();
		this.oMS.addEventListener('sourceopen', this.mediaSourceOpened );
		this.oMS.addEventListener('sourceclose', this.mediaSourceClosed );
		return window.URL.createObjectURL( this.oMS );
	};

  // Called when MediaSource object is ready
	mediaSourceOpened = () => {
		// Set live stream
		//this.oMS.duration = +Infinity;
		this.oMS.duration = Number.POSITIVE_INFINITY;
		// Empty packet queue
		// Make sure the first packet gets fed directly to the sourceBuffer or else it wont start
		this.setState({ queue: [], feed_direct: true, packets: 0 }, () => {
      // Add source buffer
      this.oSourceBuffer = this.oMS.addSourceBuffer( this.state.codecPars );
      this.oSourceBuffer.mode = 'sequence';
      this.oSourceBuffer.onupdateend = this.updateEnd.bind(this);
      // Connect Websocket
      this.wsConnect();
    });
	};

	mediaSourceClosed = () => {
		// console.log("MediaSource closed");
		this.wsDisconnect();
		this.oSourceBuffer.onupdateend = null;
    this.jumpStart();
	};

  wsConnect = () => {
		this.oWS = new WebSocket( this.props.sWSUrl );
		this.oWS.binaryType = "arraybuffer";
		this.oWS.onmessage = function (event) {
      if (typeof event.data === 'object') {
        // Video data
        this.putPacket( event.data );
      } else if(typeof event.data === 'string') {
        // Metadata (timestamp, flags, etc..)
        this.putMetadata(JSON.parse(event.data));
      }
		}.bind(this);
	}

  wsDisconnect = () => {
		this.oWS.onmessage = null;
		this.oWS.close();
		this.oWS = null;
	};

  // Called when websocket has packet data
	putPacket = ( pkt ) => {
		let incPackets = this.state.packets;
    // console.log(incPackets)
      incPackets++;
      // console.log(incPackets)
    this.setState({ packets: incPackets }, () => {
      //console.log("duration ", this.videoElement.duration, " currentTime ", this.videoElement.currentTime);
		  //console.log("diff ", this.videoElement.duration - this.videoElement.currentTime);
      if ( this.state.feed_direct ) {
        // Feed packet directly to source buffer. This must be done the first packet received
        try {
          this.oSourceBuffer.appendBuffer( pkt );
        }
        catch( err ) {
          console.log(err.message);
          this.restart();
          return;
        };
        this.setState({ feed_direct: false });
      } else {
          // Add packet to queue. Source buffer will call updateEnd(), and consume it when it's ready.
          if( this.state.queue.length < this.state.max_queue_len ){
            let stateQueue = this.state.queue;
            stateQueue.push(pkt);
            this.setState({ queue: stateQueue });
          } else {
            console.log("Packet queue full, stopping stream");
            this.stop();
          };
      };
    });
	};

  // Called when websocket has metadata
	putMetadata = async ( data ) => {
    this.updateTimestamp(data.ts);
    this.updateMotion(data.motion);
	};

  updateTimestamp = (value) => {
    // Video files are timestamped in 90000 hertz
    // Divide value by 90000 to get UNIX timestamp in seconds
    // Multiply by 1000 to get milliseconds

    const date = new Date((value / 90000) * 1000)
    const convertedTime = date.toLocaleTimeString('en-US', {timeZone: this.props.camera.sTimezone, hour12: false})
    this.setState({ts: convertedTime})
  };

  updateMotion = (value) => {
    this.setState({ motion: value });
  };

  // Called when source buffer is ready for more
	updateEnd = () => {
		if( !this.oSourceBuffer.updating ) { // really, really ready
			if( this.state.queue.length > 0 ) {

				let pkt = this.state.queue.shift(); // pop from the beginning

				//var memview = new Uint8Array(pkt);
				//console.log(" ==> writing buffer with", memview[0], memview[1], memview[2], memview[3]);

				try {
					this.oSourceBuffer.appendBuffer( pkt );
				}
				catch( err ) {
					console.log( err.message );
					this.restart();
					return;
				};

			} else {
				// Queue is empty, so the next packet is fed directly
        this.setState({ feed_direct: true });
			}
		} else {
			// so it was not?
		};
	};

  restart = () => {
		this.stop();
    this.jumpStart();
		// this.play();
	};

  play = async () => {
    // set mediasource as source of video
		// this.videoElement.current.setAttribute('src', this.initMediaSource());
    // await this.videoElement.current.setAttribute('src', this.initMediaSource());
		// Have to catch this promise or the browser will cry
		// var promise = await this.videoElement.current.play();
    // this.videoElement.current && this.videoElement.current.play();
    // console.log(promise);
		// if (promise !== undefined) {
		// 	promise.then( () => {
		// 		// Playing
    //     console.log('bazzinga!')
		// 		this.setState({ stopped: false });
		// 	})
		// 	.catch(error => {
		// 		// Play was prevented
    //     console.log('play was prevented')
		// 	});
		// };
  };

  calculateMotion = () => {
    return this.state.motion
  };

  handleDoubleClick = () => {
    console.log('handleDoubleClick')
    if (this.props.layoutConfig !== '1') {
      this.props.toggleSingleView(this.props.camera);
    }
  }

  onDragStart = (e) => {
    e.dataTransfer.setData('cameraId', this.props.camera.bID)
  }

  onDelete = () => {
    this.props.deleteCameraInView(this.props.compositeCams, this.props.camera.bID)
  }

  statusMessage = () => {
    let message = ''
    if (this.props.deviceOnline === 0) {
      message = 'Device Offline'
    } else if (this.props.camera.fOnline === 0) {
      message = 'Camera Offline'
    } else if (this.props.camera.fEnabled === 0) {
      message = 'Camera Disabled'
    } else if (this.state.loading && !this.state.connectionFail && !this.state.metaloaded) {
      if (this.state.connectionRetry > 0) {
        message = 'Attempting Stream ReLoad'
      } else {
        message = 'Stream Loading'
      }
    } else if (this.state.loading && this.state.metaloaded) {
      message = 'Meta-data Loaded. Waiting on video.'
    } else if (this.state.connectionFail) {
      message = 'Connection Failed'
    }
    return message
  }

  render() {
    const active = (this.props.deviceOnline === 1 && this.props.camera.fEnabled === 1 && this.props.camera.fOnline === 1) ? 1 : 0
    const message = this.statusMessage()
    const deviceName = this.props.devices.find(d => d.sDeviceID === this.props.camera.sDeviceID).sName

    return (
      <div onDoubleClick={this.handleDoubleClick} style={{...styles.container, cursor: this.props.user.bRole !== 3 ? 'move' : 'default'}} draggable={this.props.user.bRole !== 3 ? "true" : "false"} onDragStart={this.onDragStart} >
        <div style={{...styles.innerContainer, borderColor: this.state.motion ? 'red' : 'lightgrey'}}>
          <video
            style={active === 1 ? {objectFit: isSafari ? 'cover' : 'fill'} : { visibility: 'hidden', height: 0, width: 0 }}
            key={this.videoElement}
            ref={this.videoElement}
            width="100%"
            height="100%"
            controls={false}
            autoPlay
            muted="muted"
            preload="auto" >
          </video>

          {message !== '' &&
            <div style={styles.statusContainer}>
              <div style={{...styles.statusBox, padding: this.props.layoutConfig === '1' ? 5 : 0}}>
                <div style={styles.status}>
                  <p style={{...styles.statusLabel, color: this.state.streamError ? 'white' : 'black'}}>
                    {message}
                  </p>
                  {this.state.loading && !this.state.connectionFail && <img src={loading_icon} alt="loading" height={16} width='auto' />}
                </div>
              </div>
            </div>
          }

          <div style={styles.labelContainer}>
            <p style={styles.cameraName}>{`${deviceName} - ${this.props.camera.sName}`}</p>
            <p>{this.state.ts}</p>
            {!this.props.single && this.props.user.bRole !== 3
              && <p style={styles.deleteCamera} className="cursor-pointer" onClick={this.onDelete}>x</p>
            }
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { compositeCams, devices } = state.data;
  const { layoutConfig } =  state.config;
  const { user } = state.auth
  return {
    devices,
    compositeCams,
    layoutConfig,
    user,
  }
}

export default connect(mapStateToProps, { toggleSingleView, deleteCameraInView })(Stream);

const styles = {
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  innerContainer: {
    width: '100%',
    height: '100%',
  },
  statusContainer: {
    position: 'absolute',
    top: '40%',
    width: '100%',
    textAlign: 'center',
    zIndex: 1,
  },
  statusBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255,255,255,0.5)',
    borderRadius: 10,
    margin: 'auto',
    width: '90%',
    maxWidth: 260,
  },
  status: {
    display: 'flex',
    alignItems: 'center',
  },
  statusLabel: {
    fontSize: 12,
    marginRight: 10 ,
  },
  labelContainer: {
    zIndex: 1,
    width: 'calc(100% - 4px)',
    backgroundColor: 'rgba(0,0,0,0.6)',
    position: 'absolute',
    bottom: 2,
    left: 2,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '2px 4px 2px 0',
    color: 'white',
    fontSize: 12,
  },
  cameraName: {
    marginLeft: 5,
  },
  deleteCamera: {
    textAlign: 'center',
    backgroundColor: 'rgba(255,255,255,0.7)',
    paddingTop: 0,
    paddingBottom: 2,
    paddingRight: 10,
    paddingLeft: 10,
    zIndex: 10,
    margin: 0,
    color: 'rgba(0,0,0,0.6)',
    borderRadius: 5 ,
  },
};
